module.exports = "../dist/img/img_1-36.6750.jpg";